import { render, staticRenderFns } from "./ApplyAmbassador.vue?vue&type=template&id=4625cd04&scoped=true"
import script from "./ApplyAmbassador.vue?vue&type=script&lang=js"
export * from "./ApplyAmbassador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625cd04",
  null
  
)

export default component.exports